import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { StructureInfo } from '../../models/structure-info';
import { StructureType } from '../../enums/structure-type';
import { SettingsService } from '../../settings/settings.service';
import { SelectionArguments } from '../../models/selection-arguments';
import { SelectionType } from '../../enums/selection-type';
import { Status } from '../../models/status';
import { routeDocumentEdit, routeDocumentView } from '../../../livedokweb.routes';
import { AppUrls } from '../../../route/app-urls';

@Component({
  selector: 'ldw-structure-list-item',
  templateUrl: './structure-list-item.component.html',
  styleUrls: ['./structure-list-item.component.css'],
  standalone: false
})
export class StructureListItemComponent {
  private settingsService = inject(SettingsService);

  @Input() webDokuId = '';
  @Input() search = '';
  @Input() item!: StructureInfo;
  @Input() showTreePath = false;
  @Input() disablePreview = false;
  @Output() itemSelected: EventEmitter<SelectionArguments> = new EventEmitter();
  editRouteBase = routeDocumentEdit;
  viewRouteBase = routeDocumentView;

  /* check if editing is enabled, to switch between view and edit icon */
  allowEdit(): boolean {
    return this.settingsService.settings.pdfSettings.isEditingEnabled();
  }

  /* following methods required as enums are not resolved in *ngIf */

  isFolder(): boolean {
    return this.item.structure === StructureType.Folder;
  }

  isDocument(): boolean {
    return this.item.structure === StructureType.Document;
  }

  isNode(): boolean {
    return (
      this.item.structure === StructureType.LoopNode ||
      this.item.structure === StructureType.LoopContainer ||
      this.item.structure === StructureType.LoopName
    );
  }

  nodeIcon(): string {
    if (this.item.structure === StructureType.LoopNode) {
      return 'content_copy';
    }
    if (this.item.structure === StructureType.LoopContainer) {
      return 'perm_media';
    }
    return 'home';
  }

  getNodeImage(): string {
    if (this.item.structure === StructureType.LoopNode) {
      return AppUrls.getAssetsUrl('LoopName.png');
    }
    if (this.item.structure === StructureType.LoopContainer) {
      return AppUrls.getAssetsUrl('LoopNameContainer.png');
    }
    return AppUrls.getAssetsUrl('LoopStructureNode.png');
  }

  get status(): Status {
    if (this.item != undefined && this.item.status != undefined) {
      return this.item.status;
    }
    return Status.EMPTY;
  }

  allowPreview(): boolean {
    return !this.disablePreview && this.settingsService.settings.documentMode.useListPreview;
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }

  /*
  historyClicked(event:any){
    event.stopPropagation();  // prevent regular selection event
    this.emitEvent(SelectionType.History);
  }
  */
  previewClicked(event: any) {
    event.stopPropagation(); // prevent regular selection event
    this.emitEvent(SelectionType.Preview);
  }

  selectItem() {
    this.emitEvent(SelectionType.Selected);
  }

  selectItemIcon() {
    this.emitEvent(SelectionType.IconSelected)
  }

  editorClicked(event: any) {
    event.stopPropagation(); // prevent regular selection event
    this.emitEvent(SelectionType.Edit);
  }

  emitEvent(action: SelectionType) {
    const args = new SelectionArguments();
    args.id = this.item.id;
    args.action = action;
    args.structureType = this.item.structure;
    this.itemSelected.emit(args);
  }

}
